const plugDebounce = function (callback, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(callback, delay, ...args);
    };
};

class PlugPdpArticle extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.hasImage = (this.dataset.hasImage === "true");
        this.elements = {
            content: this.querySelector(".plug-pdp-article__content"),
            image: this.querySelector(".plug-pdp-article__image .ratio-img"),
            noAiButton: this.querySelector(".plug-pdp-article__no-ai-button"),
            toggleButton: this.querySelector(".plug-pdp-article__toggle-button-wrapper button"),
        };
        this.init();
    }

    disconnectedCallback() {
        if (this.removeListeners) {
            this.removeListeners();
        }
    }

    init() {
        this.updateCutoff();
        this.classList.add("is-initialized");
        this.removeListeners = this.initListeners();
    }

    updateCutoff() {
        const isMobile = this.isMobile();
        const isExpanded = (this.dataset.isExpanded === "true");
        if (isExpanded) {
            return;
        }
        if (this.hasImage) {
            const imageHeight = this.elements.image.offsetHeight;
            if (isMobile) {
                this.elements.content.style.maxHeight = `${imageHeight + 300}px`;
            } else {
                this.elements.content.style.maxHeight = `${imageHeight}px`;
            }
        }
    }

    initListeners() {
        const debounce = plugDebounce(this.updateCutoff.bind(this), 300);
        const resizeHandler = () => {
            debounce();
        };
        window.addEventListener("resize", resizeHandler, false);

        const toggle = () => {
            if (this.dataset.isExpanded === "false") {
                this.expand();
            } else {
                this.contract();
            }
        };
        this.elements.toggleButton.addEventListener("click", toggle, false);

        if (this.elements.noAiButton) {
            const showNoAiDisclaimer = () => {

            };
            this.elements.noAiButton.addEventListener("click", showNoAiDisclaimer, false);
        }

        return () => {
            window.removeEventListener("resize", resizeHandler, false);
            if (this.elements.noAiButton) {
                this.elements.noAiButton.removeEventListener("click", showNoAiDisclaimer, false);
            }
            this.elements.toggleButton.removeEventListener("click", toggle, false);
        };
    }

    expand() {
        this.dataset.isExpanded = "true";
        this.elements.content.style.maxHeight = "";
        this.elements.toggleButton.querySelector("span:first-child").classList.add("is-hidden");
        this.elements.toggleButton.querySelector("span:last-child").classList.remove("is-hidden");
    }

    contract() {
        this.dataset.isExpanded = "false";
        this.updateCutoff();
        this.elements.toggleButton.querySelector("span:first-child").classList.remove("is-hidden");
        this.elements.toggleButton.querySelector("span:last-child").classList.add("is-hidden");
        this.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }

    isMobile() {
        return innerWidth < 1024;
    }
}

if (!window.customElements.get("plug-pdp-article")) {
    window.customElements.define("plug-pdp-article", PlugPdpArticle);
}